//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'FeedbackMobile',
  methods: {
    goToBack() {
      this.$router.go(-1);
    },
  },
};

